import React from "react";
import DriverCompanyOrders from "./DriverCompanyOrders";

export default function DriverCompanyCompletedOrders() {
  return <DriverCompanyOrders type="completed" />;
}
